import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { createR2Folder } from 'src/actions/watcher/r2FilesActions';
import { Modal, Input, message } from 'antd';

interface Props {
  open: boolean;
  prefix: string;
  onClose: () => void;
  onCreated: () => void;
}

const CreateFolderModal = ({ open, prefix, onClose, onCreated }: Props) => {
  const dispatch = useAppDispatch();
  const activeBucketId = useAppSelector(state => state.watcher.r2Files.activeBucketId);
  const [folderName, setFolderName] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleOk() {
    if (!folderName.trim()) {
      message.warning('Please enter a folder name');
      return;
    }

    setLoading(true);
    const resultAction = await dispatch(createR2Folder({ prefix, folder_name: folderName.trim(), bucket_id: activeBucketId || undefined }));
    setLoading(false);

    if (createR2Folder.fulfilled.match(resultAction)) {
      message.success(`Folder "${folderName}" created`);
      setFolderName('');
      onCreated();
    } else {
      message.error('Failed to create folder');
    }
  }

  function handleCancel() {
    setFolderName('');
    onClose();
  }

  return (
    <Modal
      title="Create New Folder"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Create"
    >
      <Input
        placeholder="Folder name"
        value={folderName}
        onChange={e => setFolderName(e.target.value)}
        onPressEnter={handleOk}
        autoFocus
      />
    </Modal>
  );
};

export default CreateFolderModal;
